/// <amd-module name="SuiteCommerce.Blog.Post.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Post.Configuration", ["require", "exports", "SuiteCommerce.Blog.Common.Configuration", "underscore"], function (require, exports, Configuration_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PostConfiguration = /** @class */ (function (_super) {
        __extends(PostConfiguration, _super);
        function PostConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(PostConfiguration, "siteImageSizes", {
            get: function () {
                return this.get('siteSettings.imagesizes');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostConfiguration, "dateFormat", {
            get: function () {
                return this.get('siteSettings.dateformat').replace(/fm/g, '');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostConfiguration, "largeImageResize", {
            get: function () {
                var resizeId = this.get('blog.largeImageResizeId');
                return _.find(this.siteImageSizes, function (imageSize) {
                    return imageSize.name === resizeId;
                });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostConfiguration, "thumbnailImageResize", {
            get: function () {
                var resizeId = this.get('blog.thumbnailImageResizeId');
                return _.find(this.siteImageSizes, function (imageSize) {
                    return imageSize.name === resizeId;
                });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PostConfiguration, "publishedDateLabel", {
            get: function () {
                return this.translate('Published on');
            },
            enumerable: true,
            configurable: true
        });
        return PostConfiguration;
    }(Configuration_1.Configuration));
    exports.PostConfiguration = PostConfiguration;
});
